import { render } from "./MAccordion.vue?vue&type=template&id=77efc550&scoped=true"
import script from "./MAccordion.vue?vue&type=script&lang=js"
export * from "./MAccordion.vue?vue&type=script&lang=js"

import "./MAccordion.vue?vue&type=style&index=0&id=77efc550&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77efc550"]])

export default __exports__